import { Component, Input } from '@angular/core';
import { IconType } from '@shared/utils/icons';

@Component({
  selector: 'shared-ui-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.css'],
  standalone: false,
})
export class ProfilePictureComponent {
  @Input() pictureFullPath: string | null | undefined;
  @Input() size = '32px';
  iconType = IconType;
}
